module.exports = __webpack_public_path__ + "img/ship_lock.f62c4b51.svg";